import handle from './handle';
import queue from './queue';

export default [handle,queue];
